const GPROCESS_SERVICE_URL = process.env.REACT_APP_API_G_PROCESS + "/api/v1/";
const WsCode = {
  process: "process",
  addProcess: "process",
  departments: "departments",
  file: "file-attachment",
  processChangeLog: "process-change-log",
  users: "users",
  processapprove: "approval-process",
  processStep: "process-step",
  stepObject: "step-object",
  checkExistUser: "users/check-not-exists",
  steptranfer: "step-transfer-condition",
  postSteptranfer: "step-transfer-condition/create-multiple",
  postStepcheck: "step-check-list/create-multiple",
  stepcheck: "step-check-list",
  stepchild: "process-step-child",
  approveSteps: "process",
  generateToken: "generate-token",
  checkSort: "check-process-short-name",
  ticketHistory: "ticket-history",
  ticketRequest: "ticket-request",
  downloadTemplateDAT: "download-file-dat",
  tasks: "tasks",
  tasksMembersHandler: "tasks/members-handle",
  objects: "objects",
  position: "roles",
  groups: "groups",
  groupTranfer: "step-group-condition",
  postGroupTranfer: "step-group-condition/create-multiple",
  fileDowload: "file-attachment-download",
  timeSheet: "tasks",
  taskTimeSheet: "task-timesheet",
  getCheckList: "step-check-list",
  results: "tasks/results",
  processAll: "process/all",
  econtractFileTypes: "process-step/econtract-file-types",
  job_title: "job-titles",
  create_multiple_steps: "process-step/create-multiple",
  update_multiple_steps: "process-step-update-multiple",
  delete_multiple_steps: "process-step-delete-multiple",
  usersOfDepartment: "users-of-departments",
  job_title_of_department: "job-titles-of-departments",
  weekendDays: "weekend-days",
  childTicketRequest: "child-ticket-requests",
  parentProcessStep: "parent-process-steps",
  aiBot: "ai-bot",
  // T-012: "Đổi người xử lý" (change task handler) — suffixes appended after `tasks/{taskId}/`
  changeAssigneeUnits: "change-assignee/units",
  changeAssigneeAssignees: "change-assignee/assignees",
  changeAssignee: "change-assignee",
  // T-023: STAFF branch (reason popup → approval request) + cancel-pending.
  // `changeAssigneeContext` is appended after `tasks/{taskId}/` (GET .../change-assignee/context).
  // `requestChangeAssignee` is appended after `tasks/{taskId}/` (POST .../request-change-assignee).
  // `cancelChangeAssignee` is NOT under `tasks/{taskId}/...` — the route is the literal
  // `tasks/change-assignee/{requestId}/cancel` (no leading numeric task id), see routes/api.php.
  changeAssigneeContext: "change-assignee/context",
  requestChangeAssignee: "request-change-assignee",
  cancelChangeAssignee: "change-assignee",
  // T-024: "Phê duyệt đổi người xử lý" (manager approval screen for T-012/T-023 requests).
  // Full paths (no `tasks/{taskId}/` prefix): `tasks/change-assignee/approvals|approve|reject`.
  changeAssigneeApprovals: "change-assignee/approvals",
  changeAssigneeApprove: "change-assignee/approve",
  changeAssigneeReject: "change-assignee/reject",
  // T-024 (approval popup): "Người xử lý mới" dropdown source — tất cả người xử lý thuộc các
  // đơn vị approver quản lý. Full path (no `tasks/{taskId}/` prefix): `tasks/change-assignee/managed-assignees`.
  changeAssigneeManagedAssignees: "change-assignee/managed-assignees",
  // T-035 (5.6.3): "Người quản lý quy trình" — process manager candidates + dedicated change
  // endpoint. Both suffixes are appended after `process/{id}/` (see ProcessManagerApi.ts).
  // The manager is changed ONLY through `changeProcessManager`, never via the general
  // process update payload (BE strips `process_manager_id` from that path on purpose).
  processManagerCandidates: "manager-candidates",
  changeProcessManager: "manager",
};

export { GPROCESS_SERVICE_URL, WsCode };
